import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Warehouse API
export const warehouseApi = {
  getAll: () => api.get("/warehouses"),
  create: (data) => api.post("/warehouses", data),
  delete: (id) => api.delete(`/warehouses/${id}`),
};

// Product API
export const productApi = {
  getAll: (warehouseId) =>
    api.get("/products", { params: { warehouse_id: warehouseId } }),
  getAllWithBalance: (warehouseId) =>
    api.get("/products-with-balance", { params: { warehouse_id: warehouseId } }),
  getById: (id) => api.get(`/products/${id}`),
  getBySku: (sku) => api.get(`/products/sku/${sku}`),
  create: (data) => api.post("/products", data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
};

// Transaction API
export const transactionApi = {
  getAll: (params) => api.get("/transactions", { params }),
  create: (data) => api.post("/transactions", data),
};

// Invoice API
export const invoiceApi = {
  getAll: (status) => api.get("/invoices", { params: { status } }),
  createManual: (data) => api.post("/invoices/manual", data),
  upload: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/invoices/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  process: (id, warehouseId) =>
    api.post(`/invoices/process/${id}?warehouse_id=${warehouseId}`),
  delete: (id) => api.delete(`/invoices/${id}`),
};

// Dashboard API
export const dashboardApi = {
  getStats: () => api.get("/dashboard"),
  getAlerts: () => api.get("/alerts"),
};

// Export API
export const exportApi = {
  products: () => `${API}/export/products`,
  transactions: () => `${API}/export/transactions`,
};

export default api;
